import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {locale as polish} from "./i18n/pl";
import {locale as english} from "./i18n/en";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {first} from "rxjs/operators";
import {Page} from "../models/page";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DateRange} from "../models/dateRange";
import {PublicApiAccessService} from "../services/publicApiAccess.service";
import {PublicApiAccessList} from "../models/publicApiAccessList";
import {MatDialog} from "@angular/material/dialog";
import {DeletePublicAPiAccessDialogComponent} from "./dialog/deletePublicApiAccessDialog.component";
import {PublicApiAccess} from "../models/publicApiAccess";

@Component({
    templateUrl: './publicApiAccess.component.html',
    styleUrls: ['./publicApiAccess.component.scss']
})
export class PublicApiAccessComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    dateRange: DateRange;
    deleteDialogRef: any;

    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private publicApiAccessService: PublicApiAccessService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private formBuilder: FormBuilder,
        public _matDialog: MatDialog,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Public API access keys');
    }

    ngOnInit() {
        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        this.publicApiAccessService.getAll(pageInfo.offset * pageInfo.limit, pageInfo.limit).pipe(first())
            .subscribe((res: PublicApiAccessList) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    showConfirmServiceDeleteDialog(event: PublicApiAccess) {
        this.deleteDialogRef = this._matDialog.open(DeletePublicAPiAccessDialogComponent, {
            panelClass: 'delete-public-api-access-dialog',
            data      : {
                action : 'show',
                event: event,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.publicApiAccessService.delete(event.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
